import React from 'react';
import { useTranslation } from 'react-i18next';

import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import Link from '@material-ui/core/Link';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@material-ui/icons/Person';

import Tooltip from 'components/Tooltip/Tooltip';

import { Advisor } from 'common/user';
import { EdwardColors } from 'enums';

interface Props {
  advisorData: Advisor;
  short?: boolean;
  openInfoModal?: (open: boolean) => void;
  menuOpen?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& h3': {
        fontWeight: 'bold',
        margin: 0,
      },
      '& svg, & a': {
        display: 'inline-flex',
        flexWrap: 'wrap',
      },
      '& svg': {
        marginRight: theme.spacing(2),
      },
      '& a span': {
        display: 'inline-flex',
      },
      '& p': {
        marginTop: 0,
      },
    },
    line: {
      '&.MuiGrid-container': { flexWrap: 'nowrap' },
    },
    icon: {
      color: EdwardColors.GRAY_LIGHTER,
      position: 'absolute',
      left: '-4px',
      top: '-8px',
    },
  }),
);

const AdvisorInfo: React.FC<Props> = ({ advisorData, short, openInfoModal, menuOpen }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const advisorEmailParts = advisorData ? advisorData.email.split('@') : ['', ''];

  return (
    <>
      {short && (
        <Tooltip
          title={menuOpen ? '' : t('accountDetail_advisorInfo')}
          placement="right"
          inverted
        >
          <IconButton
            size="medium"
            onClick={openInfoModal ? () => openInfoModal(true) : undefined}
            className={classes.icon}
          >
            <PersonIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
      <div className={classes.root}>
        <Typography variant="h3">
          {short ? t('accountDetail_advisorContact') : `${advisorData.firstname} ${advisorData.lastname}`}
        </Typography>
        {!short && <p>{t('client_advisorContact')}</p>}
        <Grid container>
          <Grid container spacing={0} item xs={12} alignItems="center" className={classes.line}>
            <MailOutlineIcon />
            <Link underline="always" href={`mailto:${advisorData.email}`}>
              <span>{advisorEmailParts[0]}</span>
              <span>@{advisorEmailParts[1]}</span>
            </Link>
          </Grid>
          <Grid container spacing={0} item xs={12} alignItems="center" className={classes.line}>
            <PhoneIcon />
            <Link underline="always" href={`tel:${advisorData.phone}`}>
              {advisorData.phone}
            </Link>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AdvisorInfo;
